/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Parts_4_TitleInputs */

const en_mk_parts_4_title = /** @type {(inputs: Mk_Parts_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company context that stays put`)
};

const id_mk_parts_4_title = /** @type {(inputs: Mk_Parts_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konteks perusahaan yang menetap`)
};

/**
* | output |
* | --- |
* | "Company context that stays put" |
*
* @param {Mk_Parts_4_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_parts_4_title = /** @type {((inputs?: Mk_Parts_4_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Parts_4_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_parts_4_title(inputs)
	return en_mk_parts_4_title(inputs)
});